var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackTopArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "27px",
    viewBox: "0 0 11 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Backtotop_mobile",
    transform: "translate(-29.000000, -20.000000)",
    fill: "#000101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    transform: "translate(6.500000, 13.500000) scale(1, -1) translate(-6.500000, -13.500000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    transform: "translate(6.485281, 20.485281) rotate(45.000000) translate(-6.485281, -20.485281) ",
    points: "9.65749026 15.9852814 10.9852814 24.9852814 1.98528137 23.6574903"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6,
    y: 0,
    width: 1,
    height: 20
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTopArrow);
export default __webpack_public_path__ + "static/media/Back-Top-Arrow.ee8709f77679aa3229edd0292bad010a.svg";
export { ForwardRef as ReactComponent };